import { IDynamicTabLink } from '../interfaces/dynamic-tab.interface';

export const HR_BP_TABS_CONSTANT: IDynamicTabLink[] = [
  {
    to: (slug?: string) => `/hr/${slug}/information`,
    label: 'Information',
  },
  {
    to: (slug?: string) => `/hr/${slug}/exit-interview`,
    label: 'Exit Interview',
  },
  {
    to: (slug?: string) => `/hr/${slug}/clearance-form`,
    label: 'Clearance Form',
  },
];
